import { COLOR_PALETTE } from 'constants/ui';

export const DEFAULT_BACKGROUND_COLOR = COLOR_PALETTE.GRAY[1];

export const inputContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
};

export const inputControlsWrapperStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: '50px',
  gap: '4px',
};

export const labelStyles = {
  marginRight: '10px',
};

export const noWrapLabelStyles = {
  ...labelStyles,
  whiteSpace: 'nowrap',
};

export const formControlStyles = {
  display: 'flex',
};

const helperTextStyles = {
  marginLeft: 0,
};

export const helperTextClasses = { root: helperTextStyles };

export const clearButtonStyles = {
  padding: '2px',
  minWidth: 'auto',
};

export const placeholderButtonStyles = {
  padding: '2px',
  minWidth: 'auto',
};

export const hiddenInputStyles = {
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: 0,
  height: 0,
};
